// Single source of truth for the host's public contact phone number.
// Used by the host card (home), contact page, and date-inquiry dialog.
export const HOST_PHONE_DISPLAY = "+1 (612) 382-8491";
export const HOST_PHONE_E164 = "+16123828491";
export const HOST_PHONE_TEL = `tel:${HOST_PHONE_E164}`;
export const HOST_PHONE_SMS = `sms:${HOST_PHONE_E164}`;

// The cabin's main phone line — answered live 24/7 by Samantha, the booking
// concierge (Bland inbound agent). This is the number guests should CALL;
// texting goes to the host's number above.
export const CONCIERGE_PHONE_DISPLAY = "+1 (320) 335-7007";
export const CONCIERGE_PHONE_E164 = "+13203357007";
export const CONCIERGE_PHONE_TEL = `tel:${CONCIERGE_PHONE_E164}`;
